export default ({
  path  : process.env.NODE_ENV === 'development'
    ? 'http://localhost:8085/public'
    : 'https://varios.safetytrack.co/centro_control/api/public',
  sApiKeyMap: "AIzaSyAsGgRnC34wiGutlNDOOhb83VzdlZzr1i4"
})
